<template>
  <div class="invoice-list-filter">
    <BuildingFilterItem v-bind="$props" />
    <hl-Select
      label="Periode fra og med"
      v-model="periodStart"
      :options="periodOptions"
      placeholder="Velg periode"
      placeholderValue="__default__"
    />
    <hl-Select
      label="Periode til og med"
      v-model="periodEnd"
      :options="periodOptions"
      placeholder="Velg periode"
      placeholderValue="__default__"
    />
    <hl-Select
      label="Status"
      v-model="status"
      :options="statusOptions"
      placeholder="Velg status"
      placeholderValue="__default__"
    />
  </div>
</template>

<script>
import BuildingFilterItem from '@/components/reports/filters/items/BuildingFilterItem';
import FilterMixin from '@/components/reports/filters/FilterMixin';
import { columnValues } from '@/lib/reportTranslations';
import Select from '@modules/husleie-framework/src/components/forms/inputs/select/Select.vue';

export default {
  name: 'InvoiceFilter',

  components: {
    BuildingFilterItem,
    'hl-Select': Select,
  },

  mixins: [FilterMixin],

  computed: {
    periodStart: {
      get() {
        return this.getLocalSubValueOrDefault('periodStart', '__default__');
      },
      set(v) {
        this.setLocalValue('periodStart', v);
      },
    },
    periodEnd: {
      get() {
        return this.getLocalSubValueOrDefault('periodEnd', '__default__');
      },
      set(v) {
        this.setLocalValue('periodEnd', v);
      },
    },
    status: {
      get() {
        return this.getLocalSubValueOrDefault('status', '__default__');
      },
      set(v) {
        this.setLocalValue('status', v);
      },
    },
    periodOptions() {
      const options = [];
      if (!this.meta.periods) {
        return options;
      }
      const fromState = this.meta.periods.map(period => ({
        name: period,
        value: period,
      }));
      fromState.reverse();
      return options.concat(fromState);
    },
    statusOptions() {
      const options = [];
      if (!this.meta.invoiceStatuses) {
        return options;
      }
      const fromState = this.meta.invoiceStatuses.map(status => ({
        name: columnValues['invoiceStatus'][status],
        value: status,
      }));
      return options.concat(fromState);
    },
  },
};
</script>

<style scoped lang="scss">
.invoice-list-filter {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr)); // breaks at about 1280
  grid-gap: 1.25rem;
}
</style>
